export default __webpack_public_path__ + "static/media/dollarSign.5c1db0f6.svg";